import React, { useRef, useState } from "react";
import { Info } from "@phosphor-icons/react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

// Opens on hover with a mouse, on tap with touch, and on Enter/Space with a keyboard.
export const InfoTip = ({ children, label, testid, side = "top" }) => {
  const [open, setOpen] = useState(false);
  const pointer = useRef(null);
  const isMouse = (e) => e.pointerType === "mouse";

  return (
    <Popover open={open} onOpenChange={(o) => !o && setOpen(false)}>
      <PopoverTrigger asChild>
        <button
          type="button"
          aria-label={label ? undefined : "More info"}
          data-testid={testid}
          className={
            label
              ? "underline underline-offset-2 font-semibold hover:text-black"
              : "inline-flex items-center justify-center align-middle ml-1 text-black/60 hover:text-black"
          }
          onPointerDown={(e) => (pointer.current = e.pointerType)}
          onPointerEnter={(e) => isMouse(e) && setOpen(true)}
          onPointerLeave={(e) => isMouse(e) && setOpen(false)}
          onClick={(e) => {
            e.preventDefault();
            if (pointer.current === "mouse") setOpen(true);
            else setOpen((o) => !o);
            pointer.current = null;
          }}
        >
          {label || <Info size={16} weight="bold" />}
        </button>
      </PopoverTrigger>
      <PopoverContent
        side={side}
        className="max-w-xs text-sm leading-relaxed bg-white border-[1.5px] border-black rounded-xl p-3"
        onOpenAutoFocus={(e) => e.preventDefault()}
        onPointerEnter={(e) => isMouse(e) && setOpen(true)}
        onPointerLeave={(e) => isMouse(e) && setOpen(false)}
        data-testid={testid ? `${testid}-content` : undefined}
      >
        {children}
      </PopoverContent>
    </Popover>
  );
};

export default InfoTip;
